import * as React from 'react';
import { OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import { UpsaleItem } from '@features/upsale';
import BaggageIcon from '../../../../../Baggage/Baggage/components/BaggageIcon/BaggageIcon';
import { convertBaggageObject } from '../../../../../Checkout/types';
import CdnImage from '../../../../../CdnImage';
import { isInsuranceGuard } from '@widgets/upsale/lib/guards';
import { EventCategory, Log } from '../../../../../sentry';
const UpsaleService = ({ service, preselectedService, className }) => {
    const BASE_PATH = 'upsale-services';
    if (isInsuranceGuard(service)) {
        const insurance = service;
        const serviceItem = {
            header: (React.createElement(CdnImage, { contentRepo: true, path: `${BASE_PATH}/${insurance.code}.png`, fallbackUrl: `${BASE_PATH}/insurance_upsale_default.png` })),
            name: insurance.name,
            description: insurance.description,
            price: insurance.price
        };
        return React.createElement(UpsaleItem, { className: className, service: serviceItem });
    }
    const preselectedGdsService = preselectedService;
    let preselectedServicePrice = null;
    try {
        preselectedServicePrice = {
            amount: preselectedGdsService.count * preselectedGdsService.segmentIds.length * service.price.amount,
            currency: service.price.currency
        };
    }
    catch (e) {
        //  why there is no price?
        Log({
            category: EventCategory.Backend,
            message: `PreselectedServiceWithoutPrice: ${preselectedGdsService === null || preselectedGdsService === void 0 ? void 0 : preselectedGdsService.serviceId}`
        });
    }
    if (service.type === OrderAdditionalServiceGdsServiceServiceType.Baggage) {
        const baggageService = service;
        const serviceItem = {
            header: React.createElement(BaggageIcon, { realSize: true, baggage: convertBaggageObject(baggageService) }),
            name: baggageService.name,
            description: baggageService.description,
            price: preselectedServicePrice
        };
        return React.createElement(UpsaleItem, { className: className, service: serviceItem });
    }
    if (service.type === OrderAdditionalServiceGdsServiceServiceType.Meal) {
        const mealService = service;
        const serviceItem = {
            header: React.createElement("img", { alt: mealService.name, src: mealService.image }),
            name: mealService.name,
            description: mealService.description,
            price: mealService.price
        };
        return React.createElement(UpsaleItem, { className: className, service: serviceItem });
    }
    if (service.type === OrderAdditionalServiceGdsServiceServiceType.Misc) {
        const miscService = service;
        const serviceItem = {
            header: React.createElement("img", { src: miscService.image, alt: miscService.name }),
            name: miscService.name,
            description: miscService.description,
            price: preselectedServicePrice
        };
        return React.createElement(UpsaleItem, { className: className, service: serviceItem });
    }
    if (service.type === OrderAdditionalServiceGdsServiceServiceType.Vip) {
        const vipService = service;
        const serviceItem = {
            header: (React.createElement(CdnImage, { path: `${BASE_PATH}/${vipService.rfisc}.png`, fallbackUrl: `${BASE_PATH}/vip_default.png`, contentRepo: true })),
            name: vipService.name,
            description: vipService.description,
            price: preselectedServicePrice
        };
        return React.createElement(UpsaleItem, { className: className, service: serviceItem });
    }
    Log({
        category: EventCategory.Ui,
        message: `unknown service ${service === null || service === void 0 ? void 0 : service.name}`
    });
    return null;
};
export default UpsaleService;
